// extracted by mini-css-extract-plugin
export default {"container":"Store_container__DtJWL","logo":"Store_logo__9Pn78","logos":"Store_logos__sYu8S","store":"Store_store__7J7Sq"};